import { useMutation } from "@tanstack/react-query";
import { visitUser } from "../services/visit.service";

interface UseVisitMutationProps {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export const useVisitMutation = ({ onSuccess, onError }: UseVisitMutationProps = {}) => {
  return useMutation({
    mutationFn: visitUser,
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error: Error) => {
      onError?.(error);
    },
  });
};
